module.exports = __webpack_public_path__ + "img/20wjhz-pdf.351c0072.svg";